import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=6bc04c66"
import script from "./CardTitle.vue?vue&type=script&lang=ts"
export * from "./CardTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports